import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output, HostListener } from '@angular/core';
import { normalizeLeadStatus, normalizeLeadType } from 'src/app/utils/lead-status.util';

@Component({
  selector: 'app-lead-kanban-dahboard',
  templateUrl: './lead-kanban-dahboard.component.html',
  styleUrls: ['./lead-kanban-dahboard.component.scss']
})
export class LeadKanbanDahboardComponent {
  currentMobilePopupLeadId: any;
  reloading: boolean = false;
  pipelineValueId: any;
  @Input() pipelineData: any;
  @Input() dataset: any = [];
  @Input() headerColumn: any;
  @Output() updateStatus: EventEmitter<any> = new EventEmitter();
  @Input() isSaving = false;
  @Input() infoArray: any = [];
  @Input() leadFields: any = [];
  
  showStatus: any = [];
  status: any = [];
  current_id_hover: any;

  topPosition: any;
  leftPosition: any;
  hoveredRow: any;
  private hideTimer: any = null;

  leadStage: any = [];
  
  boardFields = [
    {
    key: 'info',
    name: 'Info'
  },
  //   {
  //   key: 'contact_name',
  //   name: 'Contact Name'
  // },
  // {
  //   key: 'company_name',
  //   name: 'Company Name'
  // },
  // {
  //   key: 'contact_email',
  //   name: 'Contact Email'
  // },
  // {
  //   key: 'contact_phone',
  //   name: 'Contact Phone'
  // },
  {
    key: 'lead_source',
    name: 'Lead Source'
  },
  {
    key: 'lead_type',
    name: 'Lead Type'
  },
  {
    key: 'lead_status',
    name: 'Lead Status'
  },
  {
    key: 'lead_date',
    name: 'Lead Date'
  },
  {
    key: 'lead_time',
    name: 'Lead Time'
  },
  // {
  //   key: 'designation',
  //   name: 'Designation'
  // },
  // {
  //   key: 'industry_type',
  //   name: 'Industry Type'
  // }
  ]

  ngOnInit() {

    console.log("dataset", this.dataset)
    console.log("infoArray", this.infoArray)

    this.pipelineValueId = this.pipelineData[0].pipeline_id;
    this.leadStage = this.pipelineData[0].stages;

    // Generate random colors for each stage
    this.status = this.leadStage.map((item: any) => {
      const randomColor = `rgb(${this.getRandomInt(0, 128)}, ${this.getRandomInt(0, 128)}, ${this.getRandomInt(0, 128)})`;
      return {
        value: item.stage_name,
        label: item.stage_name,
        color: randomColor
      };
    });

    this.status.forEach((element: any) => {
      this.showStatus.push(element.value); // Match with `id="{{st.value}}"`
    });
  }



  getLeadStages(e: any): void {
    const pipelineId = e.target.value;

    let stages = this.pipelineData.filter((item: any) => item.pipeline_id === pipelineId);
    console.log('stages', stages);
    if (stages.length > 0) {
      this.status = stages[0].stages.map((item: any) => {
        const randomColor = `rgb(${this.getRandomInt(0, 128)}, ${this.getRandomInt(0, 128)}, ${this.getRandomInt(0, 128)})`;
        return {
          value: item.stage_name,
          label: item.stage_name,
          color: randomColor
        };
      }
      );
      this.status.forEach((element: any) => {
        this.showStatus.push(element.value); // Match with `id="{{st.value}}"`
      });
    }
  }

  // Helper function to generate a random integer between min and max
  private getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  scrollTableTo(direction: any) {
    const el: any = document.querySelector('.content1');
    if (direction === 'right') {
      el.scrollBy({
        left: el.offsetWidth,
        behavior: 'smooth',
      });
    } else if (direction === 'left') {
      el.scrollBy({
        left: -el.offsetWidth,
        behavior: 'smooth',
      });
    }
  }

  public dropGrid(event: CdkDragDrop<string[]>): void {
    // moveItemInArray(this.status, event.previousIndex, event.currentIndex);
    console.log(event)
  }
  public drop(event: CdkDragDrop<any>, status: any): void {

    if (event.previousContainer === event.container) {

      moveItemInArray(this.dataset, event.previousIndex, event.currentIndex);
    } else {

      console.log(event.previousContainer.data)
      console.log(event.container.data)
      transferArrayItem(event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex);
      const movedTicket = event.container.data[event.currentIndex];
      // alert(movedTicket)
      movedTicket[this.headerColumn] = status;  // Set the new status for the moved ticket
      console.log(movedTicket)
      this.updateStatus.emit(movedTicket)
    }
  }

  getStatusWiseTask(status: any) {
    const columnStatus = String(status ?? '').trim();
    return this.dataset.filter((item: any) => {
      return normalizeLeadStatus(item[this.headerColumn]) === columnStatus;
    });
  }

  leadStatusLabel(status?: string | null): string {
    return normalizeLeadStatus(status);
  }

  leadTypeLabel(type?: string | null): string {
    return normalizeLeadType(type);
  }


  openEdit(content: any, data: any) {

  }

  openDeleteEvent(content: any, data: any) {

  }

  hideInfo() {
    this.current_id_hover = null;
    this.hoveredRow = null;
  }

  /** Click ⓘ to open/close (toggle). stopPropagation prevents doc:click closing it immediately */
  toggleInfo(row: any, event: MouseEvent): void {
    event.stopPropagation();
    if (this.current_id_hover === row.lead_id) {
      this.clearHideTimer();
      this.hideInfo();
    } else {
      this.clearHideTimer();
      this.openPopup(row, event);
    }
  }

  /** Hover: mouseenter on the ⓘ button */
  onInfoMouseEnter(row: any, event: MouseEvent): void {
    this.clearHideTimer();
    this.openPopup(row, event);
  }

  /** Hover: mouseleave on the ⓘ button — start a short timer so mouse can reach popup */
  onInfoMouseLeave(): void {
    this.startHideTimer();
  }

  /** Hover: mouseenter on the popup — cancel pending hide */
  onPopupMouseEnter(): void {
    this.clearHideTimer();
  }

  /** Hover: mouseleave on the popup — hide */
  onPopupMouseLeave(): void {
    this.startHideTimer();
  }

  private openPopup(row: any, event: MouseEvent): void {
    this.hoveredRow = row;
    this.current_id_hover = row.lead_id;
    this.positionPopup(event);
  }

  private startHideTimer(): void {
    this.clearHideTimer();
    this.hideTimer = setTimeout(() => this.hideInfo(), 120);
  }

  private clearHideTimer(): void {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  // kept for backward compat
  showInfo(row: any, event: any): void {
    this.openPopup(row, event);
  }

  private positionPopup(event: MouseEvent): void {
    const POPUP_W = 340;
    const POPUP_H = 460;
    const MARGIN  = 12;

    let x = event.clientX + 20;
    let y = event.clientY - 10;

    if (x + POPUP_W > window.innerWidth - MARGIN)  { x = event.clientX - POPUP_W - 10; }
    if (y + POPUP_H > window.innerHeight - MARGIN) { y = window.innerHeight - POPUP_H - MARGIN; }
    if (y < MARGIN) { y = MARGIN; }

    this.leftPosition = x;
    this.topPosition  = y;
  }

  // Close popup when user clicks anywhere outside the popup
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest('.info_class')) { return; }
    this.clearHideTimer();
    this.hideInfo();
  }

  onMouseMove(row: any, event: MouseEvent): void {
    // No-op — kept so any existing template references don't break
  }

  @HostListener('window:resize', ['$event'])
    onResize(event: Event){
      if(window.innerWidth > 768){
        this.currentMobilePopupLeadId = false;
        this.current_id_hover = false;
      }
    }
    toggleMobileInfoLead(leadId: any) {
      this.currentMobilePopupLeadId = this.currentMobilePopupLeadId === leadId ? null : leadId;
      if (this.current_id_hover === leadId) {
        this.current_id_hover = null;
      }
    }

}
